<template>
  <Card :title="$t('jobsViewer.title')" class="full-height">
    <div slot="actions">
      <button @click="updateJobs" class="slds-button slds-button_brand">Update</button>
    </div>

    <JobsTable :rows="jobsToShow" />
    <div v-if="showPaginationSection" class="pagination-section slds-m-top--medium">
      <div>
        <button class="slds-button slds-button_neutral slds-m-right--small" @click="goToPreviousPage" :disabled="pageNumber === 0"> &lt; </button>
        <span> {{ pageNumber + 1 }} </span>
        <button class="slds-button slds-button_neutral slds-m-left--small" @click="goToNextPage" :disabled="isNextButtonDisabled"> &gt; </button>
      </div>
    </div>
  </Card>
</template>
<script>
import _ from 'lodash'
import Card from '../components/slds/Card'
import JobsTable from '../components/jobs-viewer/JobsTable'
const PAGE_SIZE = 5

export default {
  components: {
    Card,
    JobsTable
  },
  data () {
    return {
      pageNumber: 0,
      jobs: []
    }
  },
  computed: {
    jobsToShow () {
      if (!this.showPaginationSection) {
        return this.jobs
      } else {
        return this.jobs.slice(this.startIndex, this.endIndex + 1)
      }
    },
    endIndex () {
      return ((this.pageNumber + 1) * PAGE_SIZE - 1)
    },
    isNextButtonDisabled () {
      return this.jobs.length <= (this.pageNumber + 1) * PAGE_SIZE
    },
    showPaginationSection () {
      return this.jobs.length > PAGE_SIZE
    },
    startIndex () {
      return this.pageNumber * PAGE_SIZE
    }
  },
  methods: {
    async retrieveJobs () {
      return this.$store.dispatch('jobs/getJobs')
    },
    async updateJobs () {
      this.jobs = _.sortBy(await this.retrieveJobs(), 'id').reverse()
    },
    goToNextPage () {
      this.currentAnimation = 'slide-fade-left-delay'
      this.pageNumber++
    },
    goToPreviousPage () {
      this.currentAnimation = 'slide-fade-right-delay'
      this.pageNumber--
    }
  },
  async created () {
    this.jobs = _.sortBy(await this.retrieveJobs(), 'id').reverse()
  }
}
</script>
<style lang="scss" scoped>
  .full-height {
    height: 100%;
  }

  .pagination-section {
    bottom: 10px;
    display: flex;
    width: 100%;
    align-items: center;

    & > div {
      margin: auto;
    }
  }
</style>
